import { globalService } from './shared/service/global.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { DataService } from './shared/service/data.service';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";

@Injectable()

export class SigninGuard implements CanActivate{
    constructor(
        private router:Router,
        private globServ:globalService,
        private _serv:DataService
        ){}
    canActivate():boolean{
        let token = this.globServ.shaToken;
        if(!this._serv.notNull(token)){
            return true;
        }else{
            const helper = new JwtHelperService();
            const isExpaired = helper.isTokenExpired(token);
            if(isExpaired){
                this.globServ.shaToken='';
                return true;
            }else{
                this.router.navigate(['/admin/dashboard'])
                return false;
            }
        }
    }
}